<span>
  <span *ngIf="car.type">{{ getCarTypeData(car.type).label }} &mdash;</span>
  {{ car.start?.toDate() | date: "dd MMMM" }}
  <span *ngIf="car?.start && (car?.from || car?.to)">
    &mdash;
  </span>
  {{ car?.from }}
  <span *ngIf="car?.from && car?.to"> › </span>{{ car?.to }}
  <span
    *ngIf="
      { start: car.start?.toDate(), end: car.end?.toDate() } | daysBetween;
      let nDays
    "
  >
    &mdash; {{ nDays }} giorni</span
  >
</span>
